/**
 * 接口权限
 * http配置
 */
import Vue from 'vue';
import store from '@/store/store';
import * as types from '@/store/types'
import LoginAboutToken from './getToken';
const loginAboutTokenFn = new LoginAboutToken();
const axios = require('axios');
const Busvue = new Vue();
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
let loading,path;
axios.interceptors.request.use(
    config => {
      path = config.url
        if (sessionStorage.token) {
            config.headers.common['Authorization'] = sessionStorage.token;
        };
        config.headers.common['appCode'] = '927f951e5e127ea1fb2582695ec7ddff';
        config.headers.common['appKey'] = '927f951e5e127ea1fb2582695ec7ddff';
        config.headers.common['Cache-Control'] = 'no-cache';
        config.headers.common['Accept'] = 'application/json';
        config.headers.Pragma = 'no-cache';
        // 尝试拦截请求内容；
        loading = Busvue.$loading({
            lock: true,
            text: '数据加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
/**
 * 退出登录清空用户信息
 */
const loginOutAndlogin = () => {
        sessionStorage.removeItem('formInfo');
        sessionStorage.removeItem('shipFormInfo');
        sessionStorage.removeItem('transferFormInfo');
        sessionStorage.removeItem('inWareAllForm');
        localStorage.removeItem('tsteetoken');
        // store.commit(types.LOGOUT);
        // loginAboutTokenFn.login();
    }
    // http response 拦截器
axios.interceptors.response.use(
    response => {
        loading.close();
        // if(response.data.code == 20001){
        //     window.location.href = window.location.origin;
        //     return
        // }
        if (response.data.code == 401) {
            window.location.href = window.location.origin;
            return
        }
        if (typeof response.data.code != "undefined" && response.data.code != 0) {
          if(path.indexOf('wechat/login')>-1){
            return response;
          }else{
            Busvue.$message({
                message: response.data.msg,
                type: 'error'
            });
          }
        } else {
            return response;
        }
    },
    error => {
        loading.close();
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 401 清除token信息并跳转到登录页面
                    loginOutAndlogin();
                    break;
                case 403:
                    Busvue.$message({
                        message: '您没有该功能使用权限。',
                        type: 'error'
                    });
                    break;
                case 504:
                    Busvue.$message({
                        message: '网络超时，请重试',
                        type: 'error'
                    });
                    break;
            }
        } else {
            // loginOutAndlogin();
        }
        // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
        console.log("axios", error);
        return Promise.reject(error.response.data);
    }
);

export default axios;


// WEBPACK FOOTER //
// ./src/host/http.js